import { getRoleFromToken } from "utils/auth";
import { getTraceId } from "utils/get-trace-id";

let isFullviewEnabled = false;
let isFullviewInitialised = false;

let identity: Window["$fvIdentity"] | null = null;

const shouldEnableFullview = () => {
  const isUK = window.location.pathname.startsWith("/uk");

  if (!isUK) {
    // Initialise for all non-UK users
    return true;
  }

  const role = getRoleFromToken();

  if (role === "agent" || role === "agent_manager") {
    // For UK - only initialise for agents
    return true;
  }

  return false;
};

export function initialiseFullview() {
  if (import.meta.env.VITE_FULLVIEW_API_KEY && shouldEnableFullview()) {
    isFullviewEnabled = true;
    const script = document.createElement("script");
    script.src = "https://install.eu1.fullview.io";
    script.setAttribute("data-org", import.meta.env.VITE_FULLVIEW_API_KEY);
    script.onload = () => {
      isFullviewInitialised = true;

      if (identity) {
        window.$fvIdentity = identity;
      }
    };
    document.head.appendChild(script);
  }
}

export function identifyFullViewUser(
  userId: string,
  properties: { region: string; name: string; email: string; roles: string[] },
) {
  if (!isFullviewEnabled) {
    return;
  }

  const { region, email, name, roles } = properties;

  const identityObj = {
    id: userId,
    name: name,
    email: email,
    disableReplaysForUser: false,
    env: `home-production`,
    roles: roles,
    customField: {
      traceId: getTraceId(),
      region,
    },
  };

  if (isFullviewInitialised) {
    window.$fvIdentity = identityObj;
  } else {
    identity = identityObj;
  }
}
